import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RECEIVED_ORDERS_PORT } from '@domain/ports/orders.port';
import { METRICS_PORT } from '@domain/ports/metrics.port';
import { PATIENT_PORT } from '@domain/ports/patient.port';
import {
  ReceivedOrder,
  IngestedOrdersMetrics,
  IngestedOrdersQueryParams
} from '@model/ingested-order/ingested-order.model';
import { FilterOptionsResponse } from '@model/filter/filter-options.model';
import { OrderStatus } from '../../../domain/types/order-status.type';
import { ManualEntryPayload } from '@model/patient/sample-entry.model';

@Injectable({
  providedIn: 'root'
})
export class ReceivedOrdersPresenter {
  private readonly ordersPort = inject(RECEIVED_ORDERS_PORT);
  private readonly metricsPort = inject(METRICS_PORT);
  private readonly patientPort = inject(PATIENT_PORT);

  getOrders(params?: IngestedOrdersQueryParams): Observable<{
    orders: ReceivedOrder[];
    pagination: {
      page: number;
      size: number;
      total: number;
      totalPages: number;
    };
  }> {
    return this.ordersPort.getOrders(params) as Observable<{
      orders: ReceivedOrder[];
      pagination: {
        page: number;
        size: number;
        total: number;
        totalPages: number;
      };
    }>;
  }

  getFilterOptions(): Observable<FilterOptionsResponse> {
    return this.ordersPort.getFilterOptions();
  }

  finalSave(caseNumbers: string[]): Observable<{
    specimenCount: number;
    message: string;
    timestamp: string;
    username: string;
  }> {
    return this.ordersPort.finalSave(caseNumbers);
  }

  getMetrics(): Observable<IngestedOrdersMetrics> {
    return this.metricsPort.getMetrics(OrderStatus.RECIBIDA);
  }

  getMetricsStream(intervalMs = 60000): Observable<IngestedOrdersMetrics> {
    return this.metricsPort.getMetricsStream(OrderStatus.RECIBIDA, intervalMs);
  }

  getSampleByCaseNumber(caseNumber: string): Observable<ManualEntryPayload> {
    return this.patientPort.getSampleByCaseNumber(caseNumber);
  }

  deleteSample(specimenCode: string): Observable<void> {
    return this.patientPort.deleteSample(specimenCode);
  }
}
